import AccountHealthModal from 'src/components/Modals/AccountHealthModal';
import NewSubaccountModal from 'src/components/Modals/CollateralModal/NewSubaccountModal';
import CreateReferralLinkModal from 'src/components/Modals/CreateReferralLinkModal';
import DelegateModal from 'src/components/Modals/DelegateModal';
import DeleteSubaccountModal from 'src/components/Modals/DeleteSubaccountModal';
import DeleteAccountModal from 'src/components/Modals/DeleteAccountModal';
import EditSubaccountModal from 'src/components/Modals/EditSubaccountModal';
import useModal from 'src/components/Modals/hooks/useModal';
import ConnectWalletModal from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModal';
import TermsOfUseModal from 'src/components/Modals/Onboarding/TermsOfUseModal/TermsOfUseModal';
import SettingsModal from 'src/components/Modals/SettingsModal/SettingsModal';
import EnableSignlessTradingModal from '../Onboarding/EnableSignlessTradingModal/EnableSignlessTradingModal';
import EnableSignlessTradingForDelegatedModal from '../Onboarding/EnableSignlessTradingModal/EnableSignlessTradingForDelegatedModal';
import SendFromWalletModal from 'src/components/Modals/SendFromWalletModal';
import ReceiveToWalletModal from 'src/components/Modals/ReceiveToWalletModal';
import dynamic from 'next/dynamic';

const PrivyDevModal = dynamic(() => import('../PrivyDevModal'));

export default function AccountModals() {
	const { currentModal } = useModal();

	return (
		<>
			{currentModal?.type === 'connect_wallet' && (
				<ConnectWalletModal {...currentModal.props} />
			)}
			{currentModal?.type === 'terms_of_use' && <TermsOfUseModal />}
			{currentModal?.type === 'settings' && (
				<SettingsModal {...currentModal.props} />
			)}
			{currentModal?.type === 'create_referral_link' && (
				<CreateReferralLinkModal />
			)}
			{currentModal?.type === 'account_health' && <AccountHealthModal />}

			{/* Note, this is also considered a "collateral" modal as it uses the collateral processor. */}
			{currentModal?.type === 'new_subaccount' && (
				<NewSubaccountModal {...currentModal.props} />
			)}
			{currentModal?.type === 'edit_subaccount' && (
				<EditSubaccountModal {...currentModal.props} />
			)}
			{currentModal?.type === 'delete_subaccount' && (
				<DeleteSubaccountModal {...currentModal.props} />
			)}

			{currentModal?.type === 'privy_dev' && <PrivyDevModal />}

			{currentModal?.type === 'enable_signless_trading' && (
				<EnableSignlessTradingModal />
			)}

			{currentModal?.type === 'enable_signless_trading_for_delegated' && (
				<EnableSignlessTradingForDelegatedModal />
			)}

			{currentModal?.type === 'delegate_account' && (
				<DelegateModal {...currentModal.props} />
			)}

			{currentModal?.type === 'send_from_wallet' && <SendFromWalletModal />}
			{currentModal?.type === 'receive_to_wallet' && <ReceiveToWalletModal />}
			{currentModal?.type === 'delete_account' && <DeleteAccountModal />}
		</>
	);
}
